module.exports = __webpack_public_path__ + "static/smarkets-e34e6e83ff40fe9eaa3c401e7085ae36.png";